<template>
  <RouterLink
    class="back-navigation"
    :to="props.destination"
  >
    <BackArrow
      aria-hidden="true"
      class="back-arrow"
    />
    {{ props.label }}
  </RouterLink>
</template>

<script setup lang="ts">
import { RouterLink, type RouteLocationNamedRaw } from 'vue-router'

import BackArrow from '@/assets/images/back.svg'

export interface Props {
  destination: RouteLocationNamedRaw
  label: string
}

const props = defineProps<Props>()
</script>

<style lang="scss" scoped>
.back-navigation {
  display: flex;
  gap: var(--spacing-minimal);
  align-items: center;

  @extend %font-body-medium;

  color: var(--text-primary);
  text-decoration: none;
  border: none;
  box-shadow: none;

  .back-arrow {
    height: 8px;
    transition: all 0.2s ease-in-out;
  }

  &:hover,
  &:focus-visible {
    text-decoration: underline;

    .back-arrow {
      transform: translateX(-20%);
    }
  }
}
</style>
